import { Pipe, PipeTransform } from '@angular/core';
import { ProjectLanguage } from '../../firestore-models/project-language';

@Pipe({
  name: 'multiTextMessage',
  standalone: false,
})
export class MultiTextMessagePipe implements PipeTransform {

  transform(values: Array<{lang_code: string, text_message: string}>, languages: Array<ProjectLanguage>,currentLang: string = 'ja'): string {
    let text_message: string = '';
    if (!!values) {
      const language = languages.find(lang => lang.lang_code === currentLang);//#216 日本語固定になっているので、admin_lang_modeに従って出し分ける
      // const language = languages[0];
      if (language) {
        for (const value of values) {
          if (language.lang_code === value.lang_code) {
            text_message = value.text_message;
            break;
          }
        }
      }
    }
    return text_message;
  }

}
